import {BrowserRouter, Route, Routes} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {lazy, Suspense, useEffect, useState} from "react";
import {onChangeScreenWidth, onPaginationChange} from "./redux/actions/layout/interaction/action";
import useNetwork from "./custom/network";
import {notification} from "antd";
import {BsWifi, BsWifiOff} from "react-icons/bs";
import {RiCloseCircleLine} from "react-icons/ri";
import {checkEnv} from "./api/system/admin/user-account";
import SettingRouter from "./components/setting/Router";
import Error403 from "./common/error/Error403";
import DG_Editor_File from "./common/file/edit";
import HRMRouter from "./components/hrm/Router";
import MainLayoutV2 from "./layoutv2";
import i18n from "i18next";


// const MainLayoutV2 = lazy(() => import("./layoutv2"));
// const HRMRouter = lazy(() => import("./components/hrm/Router"));
// const SettingRouter = lazy(() => import("./components/setting/Router"));
// const Error403 = lazy(() => import("./common/error/Error403"));
// const DG_Editor_File = lazy(() => import("./common/file/edit"));

function App() {
    const dispatch = useDispatch()
    const online = useNetwork();
    const {page, headerTitle} = useSelector(state => state.layoutInteractionReducer)
    const [lang, setLang] = useState(i18n.language);

    useEffect(() => {
        if (online !== undefined) {
            notification.open({
                key: "updateNetwork",
                icon: online ? <BsWifi/> : <BsWifiOff/>,
                message: online ? "Đã khôi phục kết nối Internet." : "Bạn đang offline.",
                placement: "bottomLeft",
                duration: online ? 5 : 0,
                closeIcon: <RiCloseCircleLine fontSize={22}/>,
                style: {
                    borderRadius: 8,
                    width: 'auto'
                }
            })
        }

    }, [online]);


    useEffect(() => {
        if (window.location.pathname?.indexOf("file") !== 1)
            document.title = getTitle()
    }, [headerTitle])

    useEffect(() => {
        if (window.innerWidth <= 1300) dispatch(onChangeScreenWidth(true));
        else dispatch(onChangeScreenWidth(false));
    }, [window.innerWidth])

    const getTitle = () => {
        const env = process.env
        if (headerTitle === null) {
            if (env.REACT_APP_MY_NAME_KEY === "LOCAL")
                return "(Local) Dogoo"
            if (process.env.NODE_ENV === "development")
                return "(Dev) Dogoo"
            else return "Dogoo"
        } else if (env.REACT_APP_MY_NAME_KEY === "LOCAL")
            return "(Local) " + headerTitle
        else if (process.env.NODE_ENV === "development")
            return "(Dev) " + headerTitle
        else return headerTitle
    }
    useEffect(() => {
        const handleLanguageChange = () => {
            setLang(i18n.language);
        };

        i18n.on("languageChanged", handleLanguageChange);
        return () => {
            i18n.off("languageChanged", handleLanguageChange);
        };
    }, []);


    useEffect(() => {
        if (window.screen.width <= 1300) dispatch(onPaginationChange(page, 4))
        checkEnv(dispatch)
    }, [])

    return (
        <>
            {/*<Suspense fallback={<div>Loading...</div>}>*/}
            <BrowserRouter>
                <Routes>
                    <Route path="/*" element={<MainLayoutV2/>}>
                        <Route path={"hrm/*"} element={<HRMRouter  key={lang}/>}/>
                        <Route path="setting/*" element={<SettingRouter  key={lang}/>}/>
                        <Route path="forbidden" element={<Error403/>}/>
                    </Route>
                    <Route path="/403" element={<Error403/>}/>
                    <Route path={"file/:planText"} element={<DG_Editor_File/>}/>
                </Routes>
            </BrowserRouter>
            {/*</Suspense>*/}
        </>

    );
}

export default App;
